import React, { useState, useEffect } from "react";
import { PostData, GetData } from "../../services/api";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Swal from 'sweetalert2';

const CampaignCreate = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [type, setType] = useState("email");
  const [subject, setSubject] = useState("");
  const [templateId, setTemplateId] = useState("");
  const [contactListIds, setContactListIds] = useState([]);
  const [availableLists, setAvailableLists] = useState([]);
  const [availableTemplates, setAvailableTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const [lists, templates] = await Promise.all([
        GetData("/contact-lists"),
        GetData("/templates/email")
      ]);
      setAvailableLists(lists.data || []);
      setAvailableTemplates(templates.data || []);
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await PostData("/campaigns", {
        name,
        type,
        subject,
        templateId: templateId || undefined,
        contactListIds,
      });
      Swal.fire({
        title: "Campaña creada",
        icon: "success"
      });
      navigate("/campaigns");
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err.message || "Error al crear la campaña",
        icon: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleListSelection = (listId) => {
    setContactListIds(prev =>
      prev.includes(listId)
        ? prev.filter(id => id !== listId)
        : [...prev, listId]
    );
  };

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title="IHubG" breadcrumbItem="Nueva Campaña" />
        <Row>
          <Col lg={8}>
            <form onSubmit={handleSubmit}>
              <FormGroup>
                <Label>Nombre de la Campaña</Label>
                <Input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  placeholder="Ej: Promoción de Verano 2025"
                />
              </FormGroup>

              <FormGroup>
                <Label>Tipo</Label>
                <Input
                  type="select"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                >
                  <option value="email">Email</option>
                  <option value="promotion">Promoción</option>
                  <option value="newsletter">Newsletter</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>Asunto</Label>
                <Input
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  placeholder="Asunto del email"
                />
              </FormGroup>

              <FormGroup>
                <Label>Plantilla</Label>
                <Input
                  type="select"
                  value={templateId}
                  onChange={(e) => setTemplateId(e.target.value)}
                >
                  <option value="">Seleccionar plantilla</option>
                  {availableTemplates.map(t => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>Listas de Contactos</Label>
                {availableLists.map(list => (
                  <div key={list.id} className="form-check">
                    <Input
                      type="checkbox"
                      checked={contactListIds.includes(list.id)}
                      onChange={() => toggleListSelection(list.id)}
                    />
                    <Label check className="ms-2">
                      {list.name} ({list.count} contactos)
                    </Label>
                  </div>
                ))}
              </FormGroup>

              <div className="d-flex gap-2 mt-4">
                <Button type="submit" color="success" disabled={loading}>
                  {loading ? "Creando..." : "Crear Campaña"}
                </Button>
                <Button type="button" color="light" onClick={() => navigate("/campaigns")}>
                  Cancelar
                </Button>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CampaignCreate;

